import SubtitleTypography from "@/components/report/commons/SubtitleTypography";
import { Stack } from "@mui/material";
import DiseaseDescriptionDialogButton from "../HelpDialog/DiseaseDescriptionDialogButton";
import { InsomniaRisk, InsomniaRiskProps } from "./InsomniaRisk";
import SASRisk, { SASRiskProps } from "./SASRisk";

export interface RiskProps {
  SAS: SASRiskProps | null;
  insomnia: InsomniaRiskProps | null;
}

export default function Risk({ SAS, insomnia }: RiskProps) {
  return (
    <Stack sx={{ mb: 12 }}>
      <Stack
        sx={{ mt: "48px", mx: 6, mb: 8 }}
        direction="row"
        justifyContent="space-between"
      >
        <SubtitleTypography>疾患のリスク</SubtitleTypography>
        <DiseaseDescriptionDialogButton />
      </Stack>
      {SAS && <SASRisk {...SAS} />}
      {insomnia && <InsomniaRisk {...insomnia} />}
    </Stack>
  );
}
